// extracted by mini-css-extract-plugin
export default {"title":"_7a4f75a57d","inner_title":"_56661d819b","charge_btn":"ecc4fdcba2"};